<template>
  <div style="width: 100%;;">
	<div v-if="errorCode">
	  <el-alert :title="errorHandler({code:errorCode})" type="error" :closable="false" center></el-alert>
	</div>
	<div v-else>
	  <slot></slot>
	</div>
  </div>
</template>

<script>
  import common from '@/common/mixins/commonUtils.js'
  export default {
    mixins:[common],
    props: ["errorCode"]
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/components/error-handler.vue